import { NextPage } from 'next';
// Hocs
import withApollo from 'hocs/withApollo';
// Helpers
import { SPORT_LANDINGS } from 'helpers/sportLandings';
// Components
import SportLanding from 'components/SportLanding/SportLanding';

const Mma: NextPage = () => <SportLanding config={SPORT_LANDINGS.mma} />;

export default withApollo(Mma);
